import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFirebase, firebaseConnect, isLoaded } from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { withRouter } from 'react-router-dom'
import t from 'tcomb-form'
import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import {
  getTaskFormTemplate
} from './DockPadFormTemplates'
import CloseIcon from '@material-ui/icons/Close'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import ButtonBase from '@material-ui/core/ButtonBase'
import { homeActions } from '../actions/home.actions'
import { entityActions } from '../actions/entity.actions'

import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'

import { styles } from './dockPadStyle'
import SelectList from '../components/SelectList'
import FileList from '../components/FileList'
import ReadReceiptDialog from '../components/Dialogs/ReadReceiptDialog'
import { alertActions } from '../actions/alert.actions'
import DockPadPillSelector from '../components/DockPadPillSelector'
import { LookAheadStatuses } from './helpers/AllTasksScreen'
import { Roles } from '../utils/Roles'
import ResourceList from '../components/ResourceList';
import { filesActions } from '../actions/files.actions';
import { getProjectUsers, getProjectUsersList, getProjectId } from '../selectors/project.selector' 
import { getCurrentUserRole } from '../selectors/user.selector'
import { getCurrentUsersScheduleSelectList, getScheduleWithTasksOrMaster } from '../selectors/schedule.selector'
import { getTaskByEntityId, getEntityId, getFormOption, getFormStruct, getTaskSelectorListWithoutTaskId } from '../selectors/task.selector'


var dockpadformTemplating = require('./formTemplate')
function hasFiles(formTemplate) {
  for (let formItem of formTemplate) {
    if (formItem.type === 'files') {
      return true
    }
  }
  return false
}

function hasAssignees(formTemplate) {
  for (let formItem of formTemplate) {
    if (formItem.type === 'assignees') {
      return true
    }
  }
  return false
}

function hasQRCode(formTemplate) {
  for (let formItem of formTemplate) {
    if (formItem.type === 'qrcode') {
      return true
    }
  }
  return false
}

function hasTaskDependencies(formTemplate) {
  for (let formItem of formTemplate) {
    if (formItem.type === 'taskDependencies') {
      return true
    }
  }
  return false
}

class EditBoardScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      orginalFormData: !!props.entity ? props.entity : {},
      formData: !!props.entity ? props.entity : {},
      assignees:
        !!props.entity && !!props.entity.assignees
          ? props.entity.assignees
          : {},
      dependencies:
        !!props.entity && !!props.entity.dependencies
          ? props.entity.dependencies
          : {},
      taskResources:
        !!props.entity && !!props.entity.taskResources
          ? props.entity.taskResources
          : {},
      files:
        !!props.entity && !!props.entity.files
            ? props.entity.files
            : [],
      branchSchedules:
        !!props.selectedSchedules
          ? props.selectedSchedules
          : []
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.state.orginalFormData ||
      JSON.stringify(this.props.editBoardInfo) !==
        JSON.stringify(nextProps.editBoardInfo)
    ) {
      this.setState({
        orginalFormData: !!nextProps.entity ? nextProps.entity : {},
        formData: !!nextProps.entity ? nextProps.entity : {},
        assignees:
          !!nextProps.entity && !!nextProps.entity.assignees
            ? nextProps.entity.assignees
            : {},
        dependencies:
          !!nextProps.entity && !!nextProps.entity.dependencies
            ? nextProps.entity.dependencies
            : {}
      })
    }
  }

  async saveEditForm() {
    const formValue = this.refs.form.getValue()
    const { dispatch, taskId, projectId } = this.props

    const { branchSchedules } = this.state
    if (!!formValue) {

      let mergedFormValue = {
        ...formValue,
        ...{
          assignees: this.state.assignees
        },
        ...{
          dependencies: this.state.dependencies
        },
        ...{
          status: this.state.lookAheadValue
        },
        ...{
          taskResources: this.state.taskResources
        }
      }

      const orginalSchedules = this.props.selectedSchedules

      const newSchedules = branchSchedules

      const scheduleAdds = Object.keys(newSchedules).filter(scheduleId => {
        return !orginalSchedules[scheduleId]
      })

      const scheduleDels = Object.keys(orginalSchedules).filter(scheduleId => {
        return !newSchedules[scheduleId]
      })

      dispatch(
        entityActions.saveFormData(
          this.props.firebase,
          projectId,
          taskId,
          mergedFormValue,
          scheduleAdds,
          scheduleDels,
          Object.keys(orginalSchedules)
        )
      )
      if(this.state.files.length > 0) {
        for(let i=0; i < this.state.files.length; i++) {
          dispatch(
            filesActions.uploadFile(this.props.selectedProject.uid, this.props.editBoardInfo.entityId, this.state.files[i])
          )
        }
      }
    } else {
      dispatch(alertActions.error('Invalid Form'))
    }
  }

  _renderAssigneeList() {
    const { formOptions } = this.props


    return (
      <SelectList
        disabled={formOptions.disabled}
        title='Responsible'
        onChange={this.onUserAssigneeSelected.bind(this)}
        optionList={this.props.projectUsers}
        value={this.state.assignees}
      />
    )
  }

  _renderBranchSchedules() {
    const { formOptions } = this.props

    return (
      <SelectList
        disabled={formOptions.disabled}
        title='Branch Schedules On'
        onChange={this.onBranchScheduleSelected.bind(this)}
        optionList={this.props.scheduleOptions}
        value={this.state.branchSchedules}
      />
    )
  }

  _renderTaskDependencies() {
    const { formOptions } = this.props


    return (
      <SelectList
        disabled={formOptions.disabled}
        title='Predecessors'
        onChange={this.onDependencySelected.bind(this)}
        optionList={this.props.otherTasks}
        value={this.state.dependencies}
      />
    )
  }

  _renderLookAheadStatus() {
    const { hasLookAheadStatus, lookahead } = this.props
    const { lookAheadValue } = this.state

    if (!hasLookAheadStatus) {
      return
    }

    if (
      !!lookahead &&
      (lookAheadValue === LookAheadStatuses.OPEN || !lookAheadValue)
    )
      return

    return (
      <DockPadPillSelector
        hasLookahead={!!lookahead}
        onValueChange={value => {
          this.setState({
            lookAheadValue: value
          })
        }}
        value={lookAheadValue}
      />
    )
  }

  async onTaskResourceChange(newTaskResources) {
    this.setState({
      taskResources: newTaskResources
    })
  }

  _renderResources() {
    const { selectedProject } = this.props
    const { taskResources } = this.state
    const resources = selectedProject.resources
    const projectResources = !!resources ? resources : {}

    return <ResourceList onChange={this.onTaskResourceChange.bind(this)} taskResources={taskResources} projectResource={projectResources} />;
  }

  _renderFileList() {
    const files = !!(this.props.entity && this.props.entity.files) ? this.props.entity.files : [];
    const {taskId} = this.props
    let filesNewTask = this.state.files

    return (
      <FileList
        value={files}
        selectedProject={this.props.selectedProject}
        taskId={taskId}
        uploadingUser={this.props.userMap}
        getFilesFromUpload={this.getFilesFromUpload.bind(this)}
        entity={this.props.entity}
        filesNewTask={filesNewTask}
      />
    )
  }

  getFilesFromUpload(newFile) {
    let currentFiles = this.state.files;
    currentFiles.push(newFile)
    this.setState({
      files: currentFiles
    })
  }



  onUserAssigneeSelected(value) {
    const newUser = value.reduce(function(map, obj) {
      map[obj.value] = true
      return map
    }, {})

    this.setState({
      assignees: newUser
    })
  }

  onBranchScheduleSelected(value) {
    const newValue = !!value ? value : []
    const newBranchSchedule = newValue.reduce(function (map, obj) {
      map[obj.value] = true
      return map
    }, {})

    this.setState({
      branchSchedules: newBranchSchedule
    })
  }

  onDependencySelected(value) {
    const newTasks = value.reduce(function(map, obj) {
      map[obj.value] = true
      return map
    }, {})

    this.setState({
      dependencies: newTasks
    })
  }

  _renderSaveButton() {
    const { classes, currentUserRole } = this.props
    if (currentUserRole === Roles.VIEWER) return

    return (
      <div style={{backgroundColor: '#fff', paddingTop: '16px', paddingBottom: '16px'}}>
        <Button
          onClick={this.saveEditForm.bind(this)}
          variant='outlined'
          color='primary'
          className={classes.saveButton}>
          Save
        </Button>
      </div>
    )
  }

  renderDeleteButton() {
    const { dispatch, projectId, taskId, currentUserRole } = this.props
    if (currentUserRole === Roles.VIEWER) return

    return (
      <MenuItem
        onClick={() => {
          dispatch(homeActions.closeMoreMenu())
          dispatch(entityActions.removeTaskByRoute(projectId, taskId))
          dispatch(homeActions.closeEditBoard())
        }}>
        Delete
      </MenuItem>
    )
  }

  render() {
    const { classes, dispatch } = this.props


    return (
      <div>
        <div className={classNames(classes.editBoardContainer)}>
          <div className={classNames(classes.editBoardHeader)}>
            <ButtonBase
              onClick={() => {
                dispatch(homeActions.closeEditBoard())
              }}
              className={classNames(classes.closeIconHeaderContainer)}>
              <CloseIcon className={classNames(classes.closeIconHeader)} />
            </ButtonBase>
            <Typography variant='headline' gutterBottom>
              Edit
            </Typography>
            <div className={classNames(classes.editBoardRightHeader)}>
              <ButtonBase
                onClick={event => {
                  dispatch(homeActions.openMoreMenu(event.currentTarget))
                }}
                className={classNames(classes.menuIconHeaderContainer)}>
                <MoreHorizIcon className={classNames(classes.menuIconHeader)} />
              </ButtonBase>
            </div>
          </div>

          <Divider />
          <t.form.Form
            ref='form'
            type={this.props.formStruct}
            value={this.state.formData}
            options={this.props.formOptions}
            onChange={this.onFormChange.bind(this)}
          />
          {this._renderAssigneeList()}
          {this._renderTaskDependencies()}
          {this._renderBranchSchedules()}
          {this._renderResources()}
          {this._renderFileList()}
          {this._renderSaveButton()}
        </div>
      </div>
    )
  }

  coerceTimeSpan(value, path) {
    if (!!value) {
      if (!!value.timeSpan) {
        const endTimePath = ['timeSpan', 'end_time']
        const startTimePath = ['timeSpan', 'start_time']
        if (
          path.toString() == startTimePath.toString() ||
          path.toString() == endTimePath.toString()
        ) {
          const startTime = moment(value.timeSpan.start_time)
          const endTime = moment(value.timeSpan.end_time)

          if (startTime.isAfter(endTime) || endTime.isBefore(startTime)) {
            if (path.toString() == startTimePath.toString()) {
              this.refs.form.getComponent(startTimePath).setState({
                value: startTime.valueOf()
              })
              this.refs.form.getComponent(endTimePath).setState({
                value: startTime.valueOf()
              })
            }
            if (path.toString() == endTimePath.toString()) {
              this.refs.form.getComponent(startTimePath).setState({
                value: endTime.valueOf()
              })
              this.refs.form.getComponent(endTimePath).setState({
                value: endTime.valueOf()
              })
            }
          }
        }
      }
    }
  }

  onFormChange(value, path) {
    const newValue = { ...value }
    this.coerceTimeSpan(newValue, path)

    this.setState({
      formData: newValue
    })
  }
}

export default compose(
  withFirebase,
  withRouter,
  withStyles(styles, { withTheme: true }),
  connect((state, props) => {
    return {
      editBoardInfo: state.editboardReducer.editBoardInfo,
      formTemplate: getTaskFormTemplate(),
      entity: getTaskByEntityId(state),
      formStruct:  getFormStruct(state),
      formOptions: getFormOption(state),
      projectUsers: getProjectUsersList(state),
      currentUserRole: getCurrentUserRole(state),
      projectId: getProjectId(state),
      taskId: getEntityId(state),
      otherTasks: getTaskSelectorListWithoutTaskId(state),
      userMap: getProjectUsers(state),
      scheduleOptions: getCurrentUsersScheduleSelectList(state),
      selectedSchedules: getScheduleWithTasksOrMaster(state)
    }
  })
)(EditBoardScreen)



// WEBPACK FOOTER //
// ./src/containers/EditBoardScreen.tsx